import React, { useState } from 'react';
import fire from '../../config/Fire';
import { NavBar } from '../nav-bar/NavBar'
import './device-mockups.css';

export const Home = (props) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  function LogoutLink() {
    function handleClick(e) {
      e.preventDefault()
      fire.auth().signOut()
    }

    return (
        <a className="nav-link" href="/logout" onClick={handleClick}>
          Logout
        </a>
    )
  }

  const exportLink = (props.userId === null) ? null : <a className="nav-link" href="/export">Export Data</a>
  const sessionLink = (props.userId === null) ? <a className="nav-link" href="/login">Organization Log In</a> : <LogoutLink />

  return (
      <div>
        <nav className="navbar navbar-expand-lg navbar-dark navbar-custom fixed-top">
          <div className="container">
            <a className="navbar-brand" href="/">Tree Tracker App</a>
            <button className="navbar-toggler" type="button" onClick={() => setIsCollapsed(!isCollapsed)}>
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className={isCollapsed ? "navbar-collapse collapse" : "navbar-collapse collapse show"} id="navbarResponsive" style={{}}>
              <ul className="navbar-nav ml-auto">
                <li className="nav-item">
                  {exportLink}
                </li>
                <li className="nav-item">
                  {sessionLink}
                </li>
              </ul>
            </div>
          </div>
        </nav>

        <NavBar {...props}/>
        <header className="masthead text-center text-white">
          <img className="logo" src="/img/logo.svg" type="image/svg+xml" />
          <div className="masthead-content">
            <div className="container">
              <h1 className="masthead-heading mb-0">Track Trees</h1>
              <h2 className="masthead-subheading mb-0">Promote Healthy Trails and Woodlands</h2>
              <a href="https://itunes.apple.com/app/id1372390809?mt=8&ign-mpt=uo%3D4">
                <img className="app-store-btn" src="/img/apple-app-store-badge.svg" type="image/svg+xml" />
              </a>
            </div>
          </div>
          <div className="bg-circle-1 bg-circle"></div>
          <div className="bg-circle-2 bg-circle"></div>
          <div className="bg-circle-3 bg-circle"></div>
          <div className="bg-circle-4 bg-circle"></div>
        </header>

        <section>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 order-lg-2">
                <div className="p-5">
                  <div className="device-container">
                    <div className="device-mockup iphone6_plus portrait white">
                      <div className="device">
                        <div className="screen">
                          <img src="img/gps-screenshot.PNG" className="img-fluid" alt="" />
                        </div>
                        <div className="button">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 order-lg-1">
                <div className="p-5">
                  <h2 className="display-4">Easily log trees</h2>
                  <p>Saving information for tree takes less than one minute! Using GPS you can
                    mark the precise location along with the condition.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="p-5">
                  <div className="device-container">
                    <div className="device-mockup iphone6_plus portrait white">
                      <div className="device">
                        <div className="screen">
                          <img src="img/list-screenshot.PNG" className="img-fluid" alt="" />
                        </div>
                        <div className="button">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="p-5">
                  <h2 className="display-4">Share data with organizations</h2>
                  <p>You are able to choose organizations for sharing your tree data. Sharing
                    data allows organizations that oversee the woodlands to address any troubled trees and
                    promote a healthy woodlands.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <footer className="py-5 bg-black">
          <div className="container">
            <p className="m-0 text-center text-white small">Copyright &copy; Tree Tracker App {new Date().getFullYear()}</p>
          </div>
        </footer>
      </div>
  )
}




// WEBPACK FOOTER //
// ./src/components/home/Home.js